import styled from "styled-components";

const StyledGalleryWrap = styled.div`
  position: relative;
  padding: 0 64px;
  margin: 80px auto;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  @media screen and (max-width: 1439px){
    padding: 0 40px;
  }
  @media screen and (max-width: 767px){
    padding: 0 24px;
    margin: 64px auto;
  }
  iframe {
    border: none;
    margin: 20px auto 0;
    width: 100%;
  }
  .thumb-cell {
    position: relative;
    flex: 0 0 230px;
    align-self: stretch;
    max-width: 300px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    @media screen and (max-width: 1023px){
      flex: 0 0 48%;
      margin-bottom: 40px;
    }
    @media screen and (max-width: 767px){
      flex: 0 0 100%;
    }
    .thumb-title {
      color: #426d74;
      font-weight: 300;
    }
    .thumb-hover-wrap {
      position: relative;
      flex: 0 0 33%;
      align-self: flex-end;
      width: 100%;
    }
    .thumb-subtitle{
      background-color: #e9e9e9;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 10px;
      img {
        width: 45px;
        margin: 0 10px;
      }
    }
    .thumb-hover {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      z-index: auto;
      height: 100%;
      opacity: 0;
      display: flex;
      align-items: center;
      text-align: center;
      color: #fff;
      background-color: ${ props => props.theme.colors.green_secondary};
      transition: opacity 0.25s ease-in-out;
      p {
        margin: 0 auto;
      }
      
      @media screen and (max-width: 1023px){
        position: relative;
        height: 30px;
        margin-top: 20px;
        opacity: 1;
      }
    }
    &:hover{
      .thumb-hover {
        opacity: 1;
      }
    }
    .thumb-copy {
      position: relative;
      .preset-12 {
        color: #426d74;
        font-weight: 500;
      }
      .preset-13 {
        color: #a1a1a1;
        margin: 10px auto;
      }
      .end-row{
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .preset-13 {
          color: #426d74;
          text-align: left;
          margin: 0 ;
        }
        img {
          flex: 0 0 33%;
          max-width: 33%;
          display: block;
        }
      }
    }
  }
`;


export {
  StyledGalleryWrap
}